import { EMPTY_FIELD } from 'constants/emptyField';

import { RecordContextProvider, useRecordContext } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { Typography } from 'shared/mui/Typography';
import { CommissionsCommentUser } from 'shared/react-admin/CommissionsComment/CommissionsCommentUser/CommissionsCommentUser';
import { CommissionStatusChipField } from 'shared/react-admin/Fields/CommissionStatusChipField/CommissionStatusChipField';
import { ReferenceField } from 'shared/react-admin/ReferenceFields';
import { CommissionComment } from 'types/embedded/commission';

import { AvatarWrapperStyled, BoxStyled } from './CommissionsComment.styled';

export const CommissionsComment: React.FC = () => {
  const record = useRecordContext<CommissionComment>();

  if (!record) {
    return EMPTY_FIELD;
  }

  return (
    <BoxStyled>
      <AvatarWrapperStyled>
        <RecordContextProvider value={record.user}>
          <CommissionsCommentUser createdAt={record.createdAt} />
        </RecordContextProvider>
        <ReferenceField
          emptyText={EMPTY_FIELD}
          label="Статус"
          link={false}
          reference="commission_statuses"
          source="updatedStatus"
        >
          <CommissionStatusChipField source="description" />
        </ReferenceField>
      </AvatarWrapperStyled>
      <Box sx={{ overflowX: 'auto' }}>
        <Typography fontSize={14}>{record?.text}</Typography>
      </Box>
    </BoxStyled>
  );
};
